// Bilingual translations for Hauswerk's Help Services landing page
export const translations = {
  de: {
    nav: {
      services: "Leistungen",
      about: "Über mich",
      contact: "Kontakt",
      callNow: "Jetzt anrufen",
    },
    hero: {
      eyebrow: "Hauswerk in Saarbrücken",
      title: "Wir helfen dort, wo Sie Unterstützung brauchen.",
      subtitle:
        "Zuverlässige, freundliche und flexible Hilfe rund um Haus, Garten, Umzug und Alltag — direkt aus Ihrer Nachbarschaft.",
      ctaPrimary: "Jetzt anrufen",
      ctaSecondary: "Leistungen ansehen",
      trustBadge: "Persönlich · Flexibel · Fair",
    },
    services: {
      eyebrow: "Was ich für Sie tue",
      title: "Leistungen",
      subtitle:
        "Fünf Bereiche, in denen ich Sie tatkräftig unterstütze. Sprechen Sie mich an — ich finde eine Lösung.",
      garden: {
        title: "Gartenhilfe",
        items: [
          "Rasen mähen",
          "Unkraut entfernen",
          "Laub aufsammeln",
          "Garten aufräumen",
          "Unterstützung bei der Gartenpflege",
        ],
      },
      household: {
        title: "Haushaltshilfe",
        items: [
          "Unterstützung bei der Reinigung",
          "Keller, Garage oder Abstellräume aufräumen",
          "Hilfe bei einfachen Haushaltsaufgaben",
        ],
      },
      moving: {
        title: "Trage- & Transporthilfe",
        items: [
          "Be- und Entladen von Fahrzeugen",
          "Hilfe beim Tragen schwerer Gegenstände",
          "Unterstützung bei Umzügen",
          "Möbel transportbereit machen",
        ],
      },
      events: {
        title: "Veranstaltungs- & Dekorationshilfe",
        items: [
          "Auf- und Abbau von Dekorationen",
          "Unterstützung bei Feiern und Veranstaltungen",
          "Aufräumen nach Veranstaltungen",
        ],
      },
      daily: {
        title: "Allgemeine Alltagshilfe",
        items: [
          "Hilfe bei kleinen Arbeiten rund ums Haus",
          "Unterstützung für Senioren",
          "Hilfe bei zeitaufwendigen Aufgaben",
          "Flexible Unterstützung nach Absprache",
        ],
      },
    },
    about: {
      eyebrow: "Über mich",
      title: "Hallo, ich bin Muhammed.",
      body:
        "Ich biete persönliche und ehrliche Hilfe rund um Haus und Garten in Saarbrücken und Umgebung. Ob kleine Reparaturen, Gartenarbeit oder Unterstützung beim Umzug — ich packe mit an, höre zu und arbeite zuverlässig.",
      points: [
        "Persönlich erreichbar — kein Callcenter",
        "Faire, transparente Absprachen",
        "Flexibel, auch kurzfristig",
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Lassen Sie uns sprechen.",
      subtitle:
        "Rufen Sie mich an oder schreiben Sie mir eine E-Mail — ich melde mich schnellstmöglich zurück.",
      phoneLabel: "Telefon",
      emailLabel: "E-Mail",
      addressLabel: "Adresse",
      cta: "Jetzt Termin vereinbaren",
    },
    footer: {
      rights: "Alle Rechte vorbehalten.",
      tagline: "Hauswerk · Saarbrücken",
    },
  },
  en: {
    nav: {
      services: "Services",
      about: "About",
      contact: "Contact",
      callNow: "Call now",
    },
    hero: {
      eyebrow: "Home & Garden Help in Saarbrücken",
      title: "We help where you need support.",
      subtitle:
        "Reliable, friendly and flexible help with your home, garden, moving and everyday tasks — right from your neighborhood.",
      ctaPrimary: "Call now",
      ctaSecondary: "View services",
      trustBadge: "Personal · Flexible · Fair",
    },
    services: {
      eyebrow: "What I do for you",
      title: "Services",
      subtitle:
        "Five areas where I actively support you. Just reach out — we'll find a solution.",
      garden: {
        title: "Garden Help",
        items: [
          "Lawn mowing",
          "Weed removal",
          "Leaf collection",
          "Garden tidying",
          "General garden care",
        ],
      },
      household: {
        title: "Household Help",
        items: [
          "Cleaning support",
          "Tidying basements, garages or storage rooms",
          "Help with simple household tasks",
        ],
      },
      moving: {
        title: "Lifting & Moving Help",
        items: [
          "Loading and unloading vehicles",
          "Carrying heavy items",
          "Help with relocations",
          "Preparing furniture for transport",
        ],
      },
      events: {
        title: "Events & Decoration Help",
        items: [
          "Setting up and removing decorations",
          "Support at celebrations and events",
          "Clean-up after events",
        ],
      },
      daily: {
        title: "Everyday Help",
        items: [
          "Help with small tasks around the house",
          "Support for seniors",
          "Help with time-consuming chores",
          "Flexible support on request",
        ],
      },
    },
    about: {
      eyebrow: "About",
      title: "Hi, I'm Muhammed.",
      body:
        "I offer personal and honest help around the house and garden in Saarbrücken and the surrounding area. Whether small repairs, gardening or moving support — I roll up my sleeves, listen carefully and work reliably.",
      points: [
        "Reach me directly — no call center",
        "Fair and transparent arrangements",
        "Flexible, even on short notice",
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk.",
      subtitle:
        "Give me a call or send a quick email — I'll get back to you as soon as possible.",
      phoneLabel: "Phone",
      emailLabel: "Email",
      addressLabel: "Address",
      cta: "Book an appointment",
    },
    footer: {
      rights: "All rights reserved.",
      tagline: "Home & Garden Help · Saarbrücken",
    },
  },
};

export const CONTACT = {
  name: "Hauswerk",
  phone: "+49 1590 6184755",
  phoneTel: "+4915906184755",
  email: "mohamadj5924@gmail.com",
  address: "Saarbrücker Straße 59, Saarbrücken",
};
